import { __ } from '@wordpress/i18n';
import { BaseControl } from '@wordpress/components';

import PanelBody from '../../../../components/PanelBody';
import ColorPicker from '../../../../components/ColorPicker';
import Slider from '../../../../components/Slider';

/**
 * Ring (border) controls: the color and width of the outline drawn around each
 * avatar so overlapping avatars stay visually separated.
 */
export default function RingPanel({ attributes, setAttributes }) {
  const { ringColor, ringWidth } = attributes;

  return (
    <PanelBody title={__('Ring', 'brandy-blocks')}>
      <BaseControl.VisualLabel>{__('Ring color', 'brandy-blocks')}</BaseControl.VisualLabel>
      <ColorPicker color={ringColor} onChange={(value) => setAttributes({ ringColor: value })} />
      <Slider
        label={__('Ring width (px)', 'brandy-blocks')}
        value={ringWidth}
        onChange={(value) => setAttributes({ ringWidth: value })}
        min={0}
        max={8}
      />
    </PanelBody>
  );
}
